import React from 'react';
import PropTypes from 'prop-types';
import { A } from '../../../hybrid/wrappers';
import { generateGridStyles } from '../components/helpers';

const Links = ({ val, gridStyles, name }) => {
    const { stylers, classes } = generateGridStyles(gridStyles, name);
    const link = { show: val.show || val, url: val.url || val };
    const title = (
        <p style={{ display: 'flex' }}>
            <p className={classes.slash} style={stylers.slash}>
                /
            </p>
            <p className={classes.link} style={stylers.link}>
                {link.show}
            </p>
        </p>
    );
    return (
        <div>
            <A className='activeLink' href={link.url}>
                {title}
            </A>
        </div>
    );
};
Links.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    styles: PropTypes.object,
    name: PropTypes.string,
    link: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default Links;
